import { TabSetNode as f } from "./TabSetNode.js";
import { BorderNode as o } from "./BorderNode.js";
function g(e) {
  const t = e.getParent();
  if (t !== null)
    if (t instanceof f) {
      let l = !1, i = 0;
      const c = t.getChildren();
      for (let n = 0; n < c.length; n++) {
        const s = c[n];
        if (s === e)
          l = !0;
        else if (!s.isFloating() && (i = n, l))
          break;
      }
      t._setSelected(i);
    } else t instanceof o && t._setSelected(-1);
}
function h(e) {
  const t = e.getParent();
  if (t !== null && (t instanceof f || t instanceof o)) {
    const l = t.getChildren();
    for (let i = 0; i < l.length; i++)
      if (l[i] === e) {
        t._setSelected(i);
        return;
      }
  }
}
function u(e, t) {
  if (e !== void 0 && (e.getType() === f.TYPE || e.getType() === o.TYPE)) {
    const l = e.getSelected();
    l !== -1 && (t === l && e.getChildren().length > 0 ? t >= e.getChildren().length && e._setSelected(e.getChildren().length - 1) : t < l ? e._setSelected(l - 1) : t > l || e._setSelected(-1));
  }
}
function S() {
  return ("10000000-1000-4000-8000" + -1e11).replace(
    /[018]/g,
    (e) => (e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16)
  );
}
export {
  u as adjustSelectedIndex,
  h as adjustSelectedIndexAfterDock,
  g as adjustSelectedIndexAfterFloat,
  S as randomUUID
};
//# sourceMappingURL=Utils.js.map
